module.exports = __webpack_public_path__ + "img/lock.706d3d7f.svg";